import { Directive, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ExgMapFitBoundsAccessor, ExgMapFitBoundsDetails } from '../services';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'exg-map-polyline-point',
  providers: [
    {provide: ExgMapFitBoundsAccessor, useExisting: forwardRef(() => ExgMapPolylinePointDirective)},
  ],
})
export class ExgMapPolylinePointDirective implements OnChanges, ExgMapFitBoundsAccessor {
  /**
   * The latitude position of the point.
   */
  @Input() public latitude!: number;

  /**
   * The longitude position of the point;
   */
  @Input() public longitude!: number;

  /**
   * This event emitter gets emitted when the position of the point changed.
   */
  @Output() positionChanged: EventEmitter<google.maps.LatLngLiteral> = new EventEmitter<google.maps.LatLngLiteral>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): any {
    // tslint:disable: no-string-literal
    if (changes['latitude'] || changes['longitude']) {
      this.positionChanged.emit({
        lat: changes['latitude'] ? changes['latitude'].currentValue : this.latitude,
        lng: changes['longitude'] ? changes['longitude'].currentValue : this.longitude,
      });
    }
    // tslint:enable: no-string-literal
  }

  /** @internal */
  getFitBoundsDetails$(): Observable<ExgMapFitBoundsDetails> {
    return this.positionChanged.pipe(
      startWith({lat: this.latitude, lng: this.longitude}),
      map(position => ({latLng: position}))
    );
  }
}
